// extracted by mini-css-extract-plugin
export default {"root":"Nav_root__3Ya63","navLink":"Nav_navLink__NcQuN","activeNavLink":"Nav_activeNavLink__UFFSN"};